// import Slider from "./Slider";
import ReviewsGear from "../MyComponents/ReviewsGear";
import ReviewForm from "../MyComponents/ReviewForm";
import ReviewBar from "../MyComponents/ReviewsBar";


function Reviews() {

    return (
        <>
            <div className="ReviewForm-parent">
                <ReviewForm />
            </div>
            <div className="Reviews-GearandBar">
                <ReviewsGear />
                <ReviewBar />
            </div>
        </>
    )

}

export default Reviews;